import { render, staticRenderFns } from "./ExpansionCardRole.vue?vue&type=template&id=051e1573&"
import script from "./ExpansionCardRole.vue?vue&type=script&lang=js&"
export * from "./ExpansionCardRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports